export default "__VITE_ASSET__BSNX1yCy__"